import { CorrectionFeedback } from '@entities/lesson'
import { useTranslation } from '@shared/config/i18n'
import { clsx } from 'clsx'
import React from 'react'

import { Box, HStack, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  feedback: CorrectionFeedback
}

export const EnglishCorrectionFeedback = ({ feedback }: Props) => {
  const t = useTranslation()
  const studentAnswer = feedback.phrase.student_sentence.map(
    (studentSentencePart: string, index: number, studentSentence: string[]) => (
      <span
        key={`student-sentence-${index}`}
        className={clsx(feedback.phrase.student_highlight.includes(index) && 'text-red-normal')}
      >
        {`${studentSentencePart}${index !== studentSentence.length - 1 ? ' ' : ''}`}
      </span>
    ),
  )
  const masterAnswer = feedback.phrase.ai_sentence.map(
    (masterSentencePart: string, index: number, materSentence: string[]) => (
      <span
        key={`student-sentence-${index}`}
        className={clsx(feedback.phrase.ai_highlight.includes(index) && 'text-blue-normal')}
      >
        {`${masterSentencePart}${index !== materSentence.length - 1 ? ' ' : ''}`}
      </span>
    ),
  )
  return (
    <React.Fragment>
      <VStack className="gap-2">
        <HStack>
          <Box className="border rounded-[14px] px-3 py-[3px] bg-white border-gray-200">
            <Typography size="body1" className="font-medium">
              {t('lesson.feedbackLabels.myExpression')}
            </Typography>
          </Box>
        </HStack>
        <VStack className="gap-0.5">
          <Typography size="h3" className={clsx('font-medium')}>
            {studentAnswer}
          </Typography>
        </VStack>
      </VStack>

      <Box className="border divide-dashed" />

      <VStack className="gap-2">
        <HStack>
          <Box className="border rounded-[14px] px-3 py-[3px] bg-white border-gray-200">
            <Typography size="body1" className="font-medium">
              {t('lesson.feedbackLabels.correctedExpression')}
            </Typography>
          </Box>
        </HStack>
        <VStack className="gap-0.5">
          <Typography size="h3" className={clsx('font-medium')}>
            {masterAnswer}
          </Typography>
        </VStack>
      </VStack>

      <Box className="border divide-dashed" />

      <VStack className="gap-2">
        <HStack>
          <Box className="border rounded-[14px] px-3 py-[3px] bg-white border-gray-200">
            <Typography size="body1" className="font-medium">
              {t('lesson.feedbackLabels.feedback')}
            </Typography>
          </Box>
        </HStack>
        <VStack className="gap-0.5">
          <Typography size="body1" className="text-gray-500">
            {feedback.phrase.ai_explanation}
          </Typography>
        </VStack>
      </VStack>
    </React.Fragment>
  )
}
